(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypeDischargeType', TypeDischargeType);

    TypeDischargeType.$inject = ['$resource'];

    function TypeDischargeType ($resource) {
        var resourceUrl =  'api/type-discharge-types/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/type-discharge-types/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
